import permissionsService from '@/services/http/permissions.service'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async fetchPermissions({ rootState }, data) {
      const res = await permissionsService.fetchPermissions(data)
      return res
    },
    async addPermissions({ rootState }, data) {
      const res = await usersService.addPermissions(data)
      return res
    },
  },
}
